export default __webpack_public_path__ + "static/1931-ea4e9b47fb945698536eba1d3e596c23.gif";